export class HistorieSlider {
  constructor() {
    this.currentIndex = 0;
  }
  init() {
    const instance = this;
    $('.historie__navigation__item').bind('click', function() {
      const indexToGoTo = $(this).data('index');
      if (indexToGoTo !== instance.currentIndex) {
          
        // ADJUST CONTENT
        $(`#historie__content__item__${instance.currentIndex}`).removeClass('historie__content__item--active');
        $(`#historie__content__item__${instance.currentIndex}`).addClass('historie__content__item');

        $(`#historie__content__item__${indexToGoTo}`).addClass('historie__content__item--active');
        $(`#historie__content__item__${indexToGoTo}`).removeClass('historie__content__item');


        // ADJUST NAVIGATION
        $(`#historie__navigation__item__${instance.currentIndex}`).removeClass('historie__navigation__item--active');
        $(`#historie__navigation__item__${instance.currentIndex}`).addClass('historie__navigation__item');

        $(`#historie__navigation__item__${indexToGoTo}`).addClass('historie__navigation__item--active');
        $(`#historie__navigation__item__${indexToGoTo}`).removeClass('historie__navigation__item');

        $(`#historie__navigation__item__${instance.currentIndex} i`).removeClass('icon-dot-historie--active');
        $(`#historie__navigation__item__${instance.currentIndex} i`).addClass('icon-dot-historie');

        $(`#historie__navigation__item__${indexToGoTo} i`).addClass('icon-dot-historie--active');
        $(`#historie__navigation__item__${indexToGoTo} i`).removeClass('icon-dot-historie');



        instance.currentIndex = indexToGoTo;
      }
    });
  }
}
